import { AdditiveBlending, BufferAttribute, BufferGeometry, Object3D, Points } from 'three';
import { appMixin } from '../../utils/appMixin';
import { RainMaterial } from '../Materials/Rain/material';

export class Rain extends appMixin(Object3D) {
  constructor(app) {
    super(app);

    const count = 500;
    const positions = new Float32Array(count * 3);
    for (let i = 0; i < count * 3; i += 3) {
      positions[i] = (Math.random() - 0.5) * 5;
      positions[i + 1] = Math.random();
      positions[i + 2] = (Math.random() - 0.5) * 5;
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new BufferAttribute(positions, 3));

    this.points = new Points(
      geometry,
      new RainMaterial({
        uniforms: this.app.uniforms,
        blending: AdditiveBlending,
        depthTest: false,
      })
    );

    this.add(this.points);
  }
}
